import { Flex, FlexProps } from '@mantine/core';
import styles from './styles.module.css';

export interface Props {
	children?: React.ReactNode;
	flexProps?: FlexProps;
}

export const CurbyHeader = (props: Props) => {
	const { children, flexProps } = props;
	return (
		<Flex align="center" direction="row" className={styles.header} {...flexProps}>
			{children}
		</Flex>
	);
};
